/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu() {
    const navigationItemSelector = '.navigation-item';
    const navigationSectionSelector = '.navigation-section';
    const navigationSectionsWrapSelector = '.navigation-sections__wrap';
    const navigationSectionParentSelector = '.navigation-sections';
    const navigationSectionLinksSelector = '.navigation-section__links';
    const navigationSectionNavigationSelector = '.navigation-section__navigation';
    const navigationSectionSingleSelector = '.navigation-sections--single-section';
    const activeStateClass = 'active';
    const enterEvents = ['focusin', 'mouseenter'];
    const exitEvents = ['focusout', 'mouseleave'];

    const init = () => {

        var exitTimer;

        const menuItemsContainers = document.querySelectorAll('.navigation-items');
        if (menuItemsContainers.length > 0) {
            menuItemsContainers.forEach(menuItemsContainer => {
                exitEvents.forEach(event => {
                    menuItemsContainer.addEventListener(event, e => {
                        clearTimeout(exitTimer);
                        exitTimer = setTimeout(function () {
                            const navItems = menuItemsContainer.querySelectorAll(navigationItemSelector);
                            navItems.forEach(navItem => {
                                navItem.closest(navigationItemSelector).classList.remove(activeStateClass);
                                navItem.querySelector(navigationSectionsWrapSelector)?.setAttribute('aria-hidden', true);
                                menuItemsContainer.querySelector(navigationSectionsWrapSelector)?.setAttribute('aria-hidden', true);
                            })
                        }, 250);
                    });
                });
            });
        }

        const parentMenuItems = document.querySelectorAll(navigationItemSelector);
        if (parentMenuItems.length > 0) {
            parentMenuItems.forEach(item => {

                exitEvents.forEach(event => {
                    item.addEventListener(event, e => {
                        e.stopPropagation();
                        document.activeElement.blur();

                    })
                    
                })

                enterEvents.forEach(event => {
                    item.addEventListener(event, e => {
                        e.stopPropagation();
                        //Remove styles on the other ones
                        parentMenuItems.forEach(item => {
                            item.closest(navigationItemSelector).classList.remove(activeStateClass);
                            item.querySelector(navigationSectionsWrapSelector)?.setAttribute('aria-hidden', true);
                        });

                        //If this is a navitem with a single section, make sure it's shown by setting the styles here
                        const singleNavigationElement = item.querySelector(navigationSectionSingleSelector);
                        if (singleNavigationElement) {
                            const sectionContentElement = singleNavigationElement.querySelector(navigationSectionLinksSelector);
                          
                            if (sectionContentElement) {

                                const sectionContentHeight = sectionContentElement.clientHeight;
                                singleNavigationElement.style.minHeight = sectionContentHeight + 'px';
                            }
                            singleNavigationElement.querySelector(navigationSectionSelector).classList.add(activeStateClass);
                        } else {
                            const mouseEnterEvent = new Event('mouseenter');
                            const firstNavigationSection = item.querySelector(navigationSectionSelector);
                            if (firstNavigationSection) {
                                firstNavigationSection.dispatchEvent(mouseEnterEvent);
                            }
                        }
                        item.closest(navigationItemSelector).querySelector('a').focus();
                        item.closest(navigationItemSelector).classList.add(activeStateClass);
                        item.querySelector(navigationSectionsWrapSelector)?.setAttribute('aria-hidden', false);
                    });
                });
            });
        }


        //Make sure everything looks good in the menu when the navigation section items is visited. This is one more level deep than above
        const navSectionNavigationItems = document.querySelectorAll(navigationSectionSelector);
        if (navSectionNavigationItems.length > 0) {
            enterEvents.forEach(eventName => {
                navSectionNavigationItems.forEach(navSectionItem => {

                    navSectionItem.addEventListener(eventName, e=> {
                        e.stopPropagation();

                        //Remove styling for other sections
                        navSectionNavigationItems.forEach(navSectionItem => {
                            const sectionsParent = navSectionItem.closest(navigationSectionParentSelector);

                            if (!sectionsParent.matches(navigationSectionSingleSelector)) {
                                sectionsParent.style.minHeight = 0 + 'px';
                                navSectionItem.classList.remove(activeStateClass);
                                navSectionItem.querySelector(navigationSectionNavigationSelector).classList.remove(activeStateClass);
                                navSectionItem.querySelector(navigationSectionLinksSelector)?.setAttribute('aria-hidden', true);
                            }
                        });

                        //Add styling for this navSection
                        const sectionsParent = navSectionItem.closest(navigationSectionParentSelector);
                        const sectionContentElement = navSectionItem.querySelector(navigationSectionLinksSelector);
                        if (sectionContentElement) {
                            const sectionContentHeight = sectionContentElement.clientHeight;
                            sectionsParent.style.minHeight = sectionContentHeight + 'px';
                        }

                        navSectionItem.classList.add('active');
                        navSectionItem.querySelector(navigationSectionNavigationSelector)?.classList.add(activeStateClass);
                        navSectionItem.querySelector(navigationSectionLinksSelector)?.setAttribute('aria-hidden', false);
                    });
                });

            });
        }


    };

    init();

}

